import { useQuery } from '../use-query';
import { extendContainerValidator, offersFilterListMode } from '../../../utils';
import { offersService } from '../../../services';

export const useOffersQuery = (keys: any = {}) => {
  if (
    typeof keys.number === 'string' &&
    (keys.number?.length < 3 || !extendContainerValidator(keys.number))
  )
    delete keys.number;
  if (Array.isArray(keys.number)) {
    delete keys.take;
    delete keys.skip;
  }

  const listMode = Array.isArray(keys.number) ? keys.listMode : 'All';

  if (keys.clientName) delete keys.clientName;
  if (keys.status === 'All') delete keys.status;

  return useQuery(
    ['sales', 'offers', JSON.stringify(keys)],
    () => {
      if (keys.listMode) delete keys.listMode;

      return offersService
        .getAll({
          params: keys,
        })
        .then((res) => {
          res.data.data = offersFilterListMode(res.data.data, listMode);
          return res.data;
        });
    },
    { initialData: { data: [], totalCount: 0 }, keepPreviousData: true },
  );
};
